module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lottery"
  }, [_c('h2', [_vm._v(_vm._s(_vm.lottery.name))]), _vm._v(" "), _c('dl', [_c('dt', {
    domProps: {
      "textContent": _vm._s(_vm.lottery.name || 'Sequenz ' + (_vm.index + 1))
    }
  }), _vm._v(" "), _c('dd', {
    staticClass: "sequence"
  }, _vm._l((_vm.sequence), function(number) {
    return _c('input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": "9"
      },
      domProps: {
        "value": number
      }
    })
  }))]), _vm._v(" "), _c('my-button', {
    on: {
      "click": _vm.generateSequence
    }
  }, [_vm._v("Zufallszahlen generieren")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-531be33c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sequence.vue
// module id = 80
// module chunks = 1